import { render, staticRenderFns } from "./AcademiaEgresadosInscription.vue?vue&type=template&id=6f45ecf8&scoped=true"
import script from "./AcademiaEgresadosInscription.vue?vue&type=script&lang=js"
export * from "./AcademiaEgresadosInscription.vue?vue&type=script&lang=js"
import style0 from "./AcademiaEgresadosInscription.vue?vue&type=style&index=0&id=6f45ecf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f45ecf8",
  null
  
)

export default component.exports